import { render, staticRenderFns } from "./TopUpDetails.vue?vue&type=template&id=03ed64c2&"
import script from "./TopUpDetails.vue?vue&type=script&lang=js&"
export * from "./TopUpDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports